import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";
import { AppHeader } from "@/components/AppHeader";
import { api, errMsg } from "@/lib/api";
import { monthRange } from "@/pages/SummaryPage";
import { fmt } from "@/lib/format";
import { useAuth } from "@/context/AuthContext";
import { ShareButtons } from "@/components/ShareButtons";
import { PersonLedgerView } from "@/components/PersonLedgerView";

export default function PersonLedgerPage() {
  const [search] = useSearchParams();
  const name = search.get("name") || "";
  const nav = useNavigate();
  const [data, setData] = useState(null);
  const { can } = useAuth();
  const [phone, setPhone] = useState("");

  useEffect(() => {
    setData(null);
    api.get("/reports/cashouts/person", { params: { name } }).then((r) => setData(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [name]);

  return (
    <div className="min-h-screen grid-paper">
      <AppHeader />
      <main className="max-w-5xl mx-auto px-4 sm:px-6 py-10 space-y-6">
        <div>
          <Link to="/cashouts" data-testid="person-ledger-back" className="text-xs font-semibold flex items-center gap-1 text-slate-600 hover:text-slate-900 mb-3">
            <ArrowLeft size={13} /> Cashout report
          </Link>
          <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-500 mb-2">Person ledger · all months</p>
          <h1 className={`text-4xl sm:text-5xl font-extrabold tracking-tight ${data?.unassigned ? "italic text-slate-500" : ""}`} data-testid="person-ledger-name">
            {data ? data.name : name || "Not specified"}
          </h1>
        </div>
        {data && data.count > 0 && can("export") && (
          <div className="flex flex-wrap items-center gap-2 bg-slate-900 text-white p-2 fade-up" data-testid="person-share-bar">
            <span className="text-[11px] font-semibold uppercase tracking-[0.12em] text-white/70 px-1">Send to {data.unassigned ? "someone" : data.name}</span>
            <input data-testid="person-share-phone-input" value={phone} inputMode="tel" placeholder="WhatsApp no. e.g. 919876543210"
              onChange={(e) => setPhone(e.target.value.replace(/[^0-9]/g, ""))}
              className="h-9 px-3 flex-1 min-w-[180px] bg-white/10 text-white placeholder:text-white/40 border border-white/20 outline-none focus:border-white font-mono text-sm" />
            <ShareButtons phone={phone} text={`${data.name} — cashout ledger (total ${fmt(data.total)})`}
              makeUrl={async () => `${window.location.origin}/p/${(await api.post("/reports/cashouts/person/share", { name })).data.token}`} />
          </div>
        )}
        {!data ? <p className="text-sm text-slate-500" data-testid="person-ledger-loading">Loading…</p> : (
          <PersonLedgerView data={data}
            onRowClick={(it, m) => nav(`/book/${it.book_id}?${it.sheet === "sett" ? "sheet=sett&" : ""}${monthRange(m.month)}`)} />
        )}
      </main>
    </div>
  );
}
